import React from 'react'
import styled from 'styled-components'
import VerticalSlider from 'uiComponents/molecules/Slider/VerticalSlider'

const StyledVerticalSlider = styled(VerticalSlider)`
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: all;
`

const ImageContainer = styled.div`
  position: relative;
  padding-bottom: 150%;
  width: 100%;
  pointer-events: none;
`

const Image = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: 50% 20%;
  background-repeat: no-repeat;
  pointer-events: all;
`

const EditorialOutfitRecoVerticalImageSlider = ({
  scrollable,
  images,
}: {
  scrollable?: boolean
  images: string[]
}) => (
  <ImageContainer>
    <StyledVerticalSlider
      scrollable={scrollable}
      controlPlacement={'left-center'}
    >
      {images.map((url, index) => {
        return (
          <ImageContainer key={index}>
            <Image style={{ backgroundImage: `url(${url})` }} />
          </ImageContainer>
        )
      })}
    </StyledVerticalSlider>
  </ImageContainer>
)

export default EditorialOutfitRecoVerticalImageSlider
